// Libs
import React, { Fragment, useContext } from "react";
// Context API
import { ExperimentContext } from "../Experiment";

const Variant = ({ type, children }) => {
  const { currentTest } = useContext(ExperimentContext);
  return (
    <Fragment>
      {Object.keys(currentTest || {}).length > 0 ? (
        <Fragment>
          {currentTest.test === false && type === "A" && children}
          {currentTest.test === true && type === "B" && children}
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default Variant;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/experiment/Variant.js